import type { ReactNode } from 'react'

import { article } from '@/shared/lib/articleStyles'

export function NewsArticleNumList({ items }: { items: ReactNode[] }) {
    return (
        <ol className={article.numList}>
            {items.map((item, index) => (
                <li key={index} className={article.numItem}>
                    {item}
                </li>
            ))}
        </ol>
    )
}
